export default "__VITE_ASSET__CAATRJvi__$_?bg__"